import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'
import classNames from 'classnames'
import { Check } from 'lucide-react'
import styles from './style.module.css'

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, id, label, ...rest }, ref) => (
    <label className={classNames(styles.wrapper, className)} htmlFor={id}>
      <span className={styles.box}>
        <input ref={ref} id={id} type="checkbox" className={styles.input} {...rest} />
        <Check size={14} className={styles.check} />
      </span>
      <span className={styles.label}>{label}</span>
    </label>
  ),
)

Checkbox.displayName = 'Checkbox'

export default Checkbox
